import { useEffect } from 'react'
import { useRouter } from 'next/router'

const MerchantLocationMenusPageContainer = (): JSX.Element => {
  const router = useRouter()
  const { merchantLocationId } = router.query

  useEffect(() => {
    if (merchantLocationId) {
      router.replace(`/portal/${merchantLocationId}/menus`)
    }
  }, [router, merchantLocationId])

  return <></>
}

export default MerchantLocationMenusPageContainer
